import React, { useRef } from 'react'
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { BsWhatsapp } from 'react-icons/bs';
import emailjs from 'emailjs-com';
const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_b824obh', 'template_wv9myha', form.current, 'l7-q4qQ7S13xJiOBm')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

            e.target.reset();
    };

    return (
        <section id="contact">
            <h5>Get in touch</h5>
            <h2>Contact Me</h2>
            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className='contact__option-icon' />
                        <h4>bp.pandey7@gmail.com</h4>
                        <a href="mailTo: bp.pandey7@gmail.com" rel="noreferrer" target="_blank">Send a message</a>
                    </article>
                    <article className="contact__option">
                        <BsWhatsapp className='contact__option-icon' />
                        <h4>+91-7838272328</h4>
                        <a href="https://api.whatsapp.com/send?phone=917838272328" rel="noreferrer" target="_blank">WhatsApp</a>
                    </article>
                </div>
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name='name' required placeholder='Your Name' />
                    <input type="email" name='email' required placeholder='Your Email' />
                    <textarea name='message' rows="7" required placeholder='Enter Your Message' />
                    <button type='submit' className='btn btn-primary'>Send Message</button>
                </form>
            </div>
        </section>
    )
}

export default Contact;